import { RelevanceTestsService } from 'src/services/RelevanceTestsService';

export const deleteRelevanceTestDefinition = (
    { accessToken, testDefinitionId }: App.RelevanceTestDefinitions.DeleteMutationVariables,
): Promise<void> => RelevanceTestsService.deleteRelevanceTestDefinition(accessToken, testDefinitionId);
